import { IconifyIcon } from '@iconify/react';
import slack from '@iconify-icons/logos/slack-icon';
import discord from '@iconify-icons/logos/discord-icon';
import microsoftTeams from '@iconify-icons/logos/microsoft-teams';
import { EWebhookFormat } from '../services/webhook.service';

/// Serviços de chat que recebem os avisos, cada um com a instrução de onde se pega a URL.
export const CHAT_SERVICES: { value: EWebhookFormat; label: string; help: string; icon: IconifyIcon }[] = [
    { value: EWebhookFormat.Slack, label: 'Slack', help: 'webhooks.ajudaSlack', icon: slack },
    { value: EWebhookFormat.Discord, label: 'Discord', help: 'webhooks.ajudaDiscord', icon: discord },
    { value: EWebhookFormat.Teams, label: 'Microsoft Teams', help: 'webhooks.ajudaTeams', icon: microsoftTeams },
];
